import React from "react";
import styled from "styled-components";
import {ellipsis, tableBorderColour} from "../../../../style/styleConsts";

const Td = styled.td`
    border-bottom: 1px solid ${tableBorderColour};
    padding: 5px 10px;
`;

const Name = styled.div`
    ${ellipsis};
    max-width: 120px;
`;

export const SectorsRow = ({name, sentimentChart, volumeChart}) => (
    <tr>
        <Td className="t-sector-names">
            <Name>{name}</Name>
        </Td>
        <Td>
            {sentimentChart}
        </Td>
        <Td>
            {volumeChart}
        </Td>
    </tr>
);
